'use client';

import { signIn } from 'next-auth/react';
import Image from 'next/image';
import BrandLogo from '@/resources/brand.svg';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

function useAuthRedirect() {
  const { status } = useSession();

  useEffect(() => {
    if (status === 'authenticated') {
      window.location.href = '/';
    }
  }, [status]);
}

export default function LoginPage() {
  useAuthRedirect();
  return (
    <div className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat">
      <div className="relative z-10 bg-white rounded-2xl shadow-xl border border-gray-200 p-8 w-full max-w-md mx-4">
        <div className="flex justify-center mb-8">
          <Image src={BrandLogo} alt="Sennder Logo" width={200} priority />
        </div>

        <div className="text-center mb-8">
          <h1 className="text-2xl text-gray-900 mb-2">Welcome</h1>
          <p className="text-gray-600 text-sm">
            Log in to sennder to continue to Traffic Tool
          </p>
        </div>

        <button
          onClick={() => signIn('google')}
          className="cursor-pointer w-full flex items-center justify-center gap-3 px-6 py-3 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 font-medium text-gray-700"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          Sign in with Google
        </button>

        <button
          onClick={() => signIn("azure-ad")}
          className="cursor-pointer w-full flex items-center justify-center gap-3 px-6 py-3 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 font-medium text-gray-700 mt-3"
        >
          <svg className="w-5 h-5" viewBox="0 0 23 23">
            <path fill="#f3f3f3" d="M0 0h23v23H0z" />
            <path fill="#f35325" d="M1 1h10v10H1z" />
            <path fill="#81bc06" d="M12 1h10v10H12z" />
            <path fill="#05a6f0" d="M1 12h10v10H1z" />
            <path fill="#ffba08" d="M12 12h10v10H12z" />
          </svg>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
